import React, { useEffect } from "react";
import { app } from "./firebase";
import { getAuth, signInAnonymously } from "firebase/auth";
import { Routes, Route, useLocation } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import PrivateRoute from "./components/PrivateRoute";
import RegisterPage from "./pages/RegisterPage";
import AdminSetupPage from "./pages/AdminSetupPage";
import EventWelcomePage from "./pages/EventWelcomePage";
import Navbar from "./components/Navbar";
import GuestFormPage from "./pages/GuestFormPage";
import EventSlideshow from "./components/EventSlideshow";
import HomePage from "./pages/HomePage";
import EventCollagePage from "./pages/EventCollagePage";
import AdminEventManagerPage from "./pages/AdminEventManagerPage";
import WelcomePage2 from "./pages/WelcomePage";

const AppLayout = ({ children }) => {
  const location = useLocation();
  const hideNavbar =
    (location.pathname.includes("/event/") &&
      location.pathname.includes("/welcome")) ||
    location.pathname === "/welcome2";

  return (
    <div>
      {!hideNavbar && <Navbar />}
      {children}
    </div>
  );
};

function App() {
  useEffect(() => {
    const auth = getAuth(app);

    if (!auth.currentUser) {
      signInAnonymously(auth)
        .then(() => {
          console.log("✅ Signed in anonymously");
        })
        .catch((error) => {
          console.error("❌ Anonymous sign-in failed", error);
        });
    }
  }, []);

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/welcome2" element={<WelcomePage2 />} />
        <Route
          path="/admin/setup"
          element={
            <PrivateRoute>
              <AdminSetupPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/event/:shortCode/welcome"
          element={<EventWelcomePage />}
        />
        <Route path="/event/:shortCode/form" element={<GuestFormPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="slideshow" element={<EventSlideshow />} />
        <Route
          path="/event/:shortCode/collage"
          element={<EventCollagePage />}
        />
        <Route path="/manager" element={<AdminEventManagerPage />} />
      </Routes>
    </AppLayout>
  );
}

export default App;
